import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BillingService } from '../../../../services/billing.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material';
import { MatSnackBar } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TransactionDetail } from '../../../../models/transaction.model';
import { WMSValidators } from '../../../../shared/validators';

@Component({
    selector: 'dialog-other-government-edit-transaction',
    templateUrl: 'dialog.edittransaction.html',
    styleUrls: ['dialog.edittransaction.css']
})
export class EditOtherGovernmentTransactionDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    errorMessage: string = '';
    edittransform: FormGroup;
    loading: boolean = true;
    objects = [];
    warrant_auth_code: string = 'OT';
    isSubmit: boolean = false;
    transDetail: TransactionDetail = new TransactionDetail();

    constructor(public dialogRef: MatDialogRef<EditOtherGovernmentTransactionDialog>,
        @Inject(MAT_DIALOG_DATA) public editdata: any,
        private billingService: BillingService,
        public snackBar: MatSnackBar,
        public dialog: MatDialog) { }

    ngOnInit() {
        this.edittransform = new FormGroup({
            pnr: new FormControl({ value: '', disabled: true }),
            bookingdate: new FormControl({ value: '', disabled: true }),
            agencycode: new FormControl({ value: '', disabled: true }),
            pukalnumber: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(10)]),
            selectedobject: new FormControl({ value: '', disabled: true }),
            billserialno: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(25)]),
            paymentdate: new FormControl({ value: '', disabled: true }),
            basefare: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            airporttax: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            insurance: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            adminfee: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            vat: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            fuelsurcharge: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            noluranwajibjasa: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            servicescharge: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            paymentamount: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency])
        });

        let edit_init_sub = this.billingService.getTransactionDetail(this.editdata.selectedBillId, this.warrant_auth_code)
            .subscribe(
                (value) => {
                    this.loading = false;
                    this.edittransform.setValue({
                        pnr: value.Bill_Pnr,
                        bookingdate: value.Bill_Booking_Dt,
                        agencycode: value.Bill_Agency_Code,
                        pukalnumber: value.Bill_Acc_No,
                        selectedobject: value.Bill_Obj_Id,
                        billserialno: value.Bill_Serial_No,
                        paymentdate: value.Bill_Pymnt_Dt,
                        basefare: value.Bill_Base_Fare_Amt,
                        airporttax: value.Bill_Air_Port_Tax,
                        insurance: value.Bill_Insurance,
                        adminfee: value.Bill_Admin_Fee,
                        vat: value.Bill_Vat,
                        fuelsurcharge: value.Bill_Fuel_Surcharge,
                        noluranwajibjasa: value.Bill_No_Luran_Wajib_Jasa,
                        servicescharge: value.Bill_Services_Charge,
                        paymentamount: value.Bill_Pymnt_Amt
                    });

                    this.objects = value.TransObjects;
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(edit_init_sub);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to save the changes?");

        if (cfm) {
            this.isSubmit = true;
            this.loading = true;

            let check_valid_sub = this.billingService.checkOTHValidPukalNumber(this.edittransform.get('pukalnumber')!.value)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {

                        } else if (value.status === 200 && value.body === 1) {
                            this.saveTransaction();
                        } else {
                            this.openSnackBar('Invalid Pukal Number. Please make sure Pukal Number is valid.', '');
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(check_valid_sub);
        } else {
            this.isSubmit = false;
        }
    }

    saveTransaction() {
        this.transDetail.Bill_Acc_No = this.edittransform.value.pukalnumber;
        this.transDetail.Bill_Serial_No = this.edittransform.get('billserialno')!.value;
        this.transDetail.Bill_Obj_Id = this.edittransform.get('selectedobject')!.value;
        this.transDetail.Bill_Id = this.editdata.selectedBillId;
        this.transDetail.Bill_Base_Fare_Amt = this.edittransform.get('basefare')!.value;
        this.transDetail.Bill_Air_Port_Tax = this.edittransform.get('airporttax')!.value;
        this.transDetail.Bill_Insurance = this.edittransform.get('insurance')!.value;
        this.transDetail.Bill_Admin_Fee = this.edittransform.get('adminfee')!.value;
        this.transDetail.Bill_Vat = this.edittransform.get('vat')!.value;
        this.transDetail.Bill_Fuel_Surcharge = this.edittransform.get('fuelsurcharge')!.value;
        this.transDetail.Bill_No_Luran_Wajib_Jasa = this.edittransform.get('noluranwajibjasa')!.value;
        this.transDetail.Bill_Services_Charge = this.edittransform.get('servicescharge')!.value;
        this.transDetail.Bill_Pymnt_Amt = this.edittransform.get('paymentamount')!.value;

        let update_sub = this.billingService.updateSelectedTransaction(this.transDetail)
            .subscribe(
                (value) => {
                    if (value.status === 204) {

                    } else if (value.status === 200) {
                        this.openSnackBar('Changes saved.', '');
                        this.dialogRef.close('Edit successful');
                    } else {
                        this.openSnackBar('Error loading edit transaction.', '');
                    }
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(update_sub);
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}